import { Select } from "antd";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ISelectOption } from "../../../interfaces/ISelectOption";
import { COLORS } from "../../constants/colors";



const Wrapper = styled.div<any>`
    display: flex;
    position: relative;
    align-items:center;
    background-color: ${(props) => !!props.disabled ? COLORS.black_back_color5 : props.backgroundColor} !important;
    border-radius: 5px !important;
    border: 1px solid ${(props) => props.borderColor} !important;
    height:  ${(props) => props.height} !important;

    .icon {
        position: absolute;
        font-size: 1em;
        padding-left: .45em;
        padding-top: .1em;
        color: ${(props) => props.borderColor};
    }
`;

const StyledSelect = styled(Select) <any>`
    width: 100% !important;
    line-height: ${(props) => props.height} !important;
    height:  ${(props) => props.height} !important;
    
    .ant-select-selector {
        color: ${(props) => props.textColor} !important;
        border: none !important;
        outline: none !important;
        background-color: transparent !important;
        height: ${(props) => props.height} !important;
    }

    .ant-select-selection-placeholder {
        color: ${(props) => props.borderColor};
        font-weight: 300;
        opacity: 0.5;
        font-size: 1.1em;
        line-height: ${(props) => props.height} !important;
        padding-left: ${(props) => !!props.icon ? '1em' : '0em'} !important;
    }

    .ant-select-selection-item {
        font-size: 1.1em !important;
        font-weight: 300 !important;
        line-height: ${(props) => props.height} !important;
        padding-left: ${(props) => !!props.icon ? '1em' : '0em'} !important;
    }
    
    .ant-select-selection-search {
        padding-left: ${(props) => !!props.icon ? '1em' : '0em'} !important;
    }

    .ant-select-arrow {
         color: ${(props) => props.borderColor};
    }
`



interface Props {
    options: ISelectOption[];
    borderColor: string;
    textColor: string;
    backgroundColor: string;
    value: any;
    onChange: any;
    placeholder: string;
    disabled: boolean;
    defaultValue?: any;
    loading?: boolean;
    allowClear?: boolean;
    icon?: string;
    height?: string;
}
const { Option } = Select;

const SelectBox = ({ options, borderColor, textColor, value, allowClear = true, defaultValue, backgroundColor, onChange, placeholder, disabled, icon, height = '38px', loading = false }: Props) => {

    return (
        <Wrapper
            borderColor={borderColor}
            textColor={textColor}
            backgroundColor={backgroundColor}
            disabled={disabled}
            height={height}
        >
            {!!icon &&
                <i className={`${icon} icon`}></i>
            }
            <StyledSelect
                showSearch
                filterOption={(input: any, option: any) => (option!.children as string).toLowerCase().includes(input.toLowerCase())}
                loading={loading}
                value={!!value ? value.toString() : null}
                defaultValue={!!value ? value.toString() : null}
                placeholder={placeholder}
                disabled={disabled}
                onSelect={(value: any) => onChange(!!value ? value.toString() : '')}
                onDeselect={() => onChange(null)}
                allowClear={allowClear}
                icon={icon}
                borderColor={borderColor}
                textColor={textColor}
                height={height}
            >
                {options.map(opt => (
                    <Option key={opt.key} value={opt.value}>{opt.text}</Option>
                ))}
            </StyledSelect>
        </Wrapper>
    )
}
export default SelectBox;